import { useBrandingContext } from '@group-link-one/gl-components';
import type { IBranding } from '@/Branding/_Types/Branding.types';
import { FallbackTemplate } from '@/Templates/FallBack/FallBack.template';
import { useFallBackTranslate } from '@/Templates/FallBack/hooks/useFallBackTranslate';

export const Instability = ({ customHeight }: { customHeight?: string }) => {
  const { customLocale } = useFallBackTranslate();

  const { brandingData } = useBrandingContext() as { brandingData: IBranding };

  return (
    <FallbackTemplate
      logoOptions={{
        src: {
          logoLight: brandingData.Onboard.logo,
          logoDark: brandingData.Onboard.logo_dark,
        },
        alt: 'GroupLink logo',
      }}
      title={customLocale('instability.title')}
      subtitle={customLocale('instability.subtitle')}
      description={customLocale('instability.description')}
      hasButton={false}
      customHeight={customHeight}
    />
  );
};
